import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App Error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#0a1929] text-white p-8">
          <div className="max-w-md text-center">
            <div className="mb-6">
              <span className="text-2xl font-bold">
                K<span className="text-[#48a8ab]">AI</span>YA
              </span>
              <span className="ml-2 text-sm text-gray-400">SOLUTIONS</span>
            </div>
            
            <h1 className="text-xl font-semibold mb-4">
              Something went wrong
            </h1>
            
            <p className="text-gray-400 mb-6">
              We apologize for the inconvenience. Please try refreshing the page or contact us directly.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={this.handleReload}
                className="bg-[#48a8ab] hover:bg-[#3d9194] text-white px-6 py-3 rounded-md font-medium transition-colors"
              >
                Refresh Page
              </button>
              
              <a
                href="tel:775-722-4569"
                className="border border-[#48a8ab] text-[#48a8ab] hover:bg-[#48a8ab] hover:text-white px-6 py-3 rounded-md font-medium transition-colors text-center"
              >
                Call 775-722-4569
              </a>
            </div>
            
            <div className="mt-8 pt-6 border-t border-gray-700">
              <p className="text-sm text-gray-500">
                Or email us at{' '}
                <a href="mailto:kyto@kaiyasolutions.com" className="text-[#48a8ab] hover:underline">
                  kyto@kaiyasolutions.com
                </a>
              </p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
